"use client";

import { useParams } from "next/navigation";
import { isLocale, messagesFor } from "@/lib/i18n/locales";

export default function LocaleError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const params = useParams<{ locale?: string }>();
  const locale = params.locale && isLocale(params.locale) ? params.locale : "en";
  const messages = messagesFor(locale);
  return (
    <main id="main-content" className="error-page">
      <h1>{messages.errorTitle}</h1>
      <p>{messages.errorDescription}</p>
      <button type="button" onClick={reset}>
        {messages.errorAction}
      </button>
    </main>
  );
}
